import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=445ea770&scoped=true&"
import script from "./Message.vue?vue&type=script&lang=js&"
export * from "./Message.vue?vue&type=script&lang=js&"
import style0 from "./Message.vue?vue&type=style&index=0&id=445ea770&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445ea770",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Message.vue
// module id = null
// module chunks = 